export enum TestConfigStepType {
  SET_OPPOSITION = 'SET_OPPOSITION',
  SET_EXAM_TYPE_OR_CHALLENGE = 'SET_EXAM_TYPE_OR_CHALLENGE',
  SET_EXAM_TYPE = 'SET_EXAM_TYPE',
  SET_EXAM_TEMPLATE = 'SET_EXAM_TEMPLATE',
  SET_NUM_QUESTIONS = 'SET_NUM_QUESTIONS',
  SET_CONTENTS = 'SET_CONTENTS',
  SET_ORGANIZATION = 'SET_ORGANIZATION',
  CREATE_CHALLENGE = 'CREATE_CHALLENGE',
  FINISH = 'FINISH',
}

export interface TestConfigStep {
  stepType: TestConfigStepType;
  isCompleted: boolean;
}

export interface TestConfiguratorStepsData {
  currentStepIndex: number;
  steps: TestConfigStep[];
  /**
   * Is true when every step is completed
   */
  isConfigCompleted: boolean;
}

export interface TestConfigStepsContextValue {
  configStepsData: TestConfiguratorStepsData;
  /**
   * Set current step as completed, updating next steps information if needed, and moves to next incomplete step.
   * @props isChanged: set as true when step value is changed to update related next steps.
   */
  completeCurrentStep: ({ isChanged }: { isChanged: boolean }) => void;
  matchCompletedStepsWithConfigData: () => void;
  /**
   * Moves to the step with given step type and set status as not completed.
   */
  goToStep: (stepIndex: number) => void;
  /**
   * Returns step data and index for step with given type.
   */
  getStepByType: (
    stepType: TestConfigStepType,
  ) => { stepIndex: number; stepData: TestConfigStep; isCurrentStep: boolean };
}
